import css from 'styled-jsx/css';
import { colors, fontSizes } from '../../../../themes';

export default css`
  .disambiguation-list {
    background: ${colors.white};
    height: auto;
    list-style: none;
    padding: 15px;
    margin: 0;
    width: 100%;
  }

  .title {
    color: #252525;
    font-size: ${fontSizes.small};
    font-weight: bold;
    margin: 0;
    text-transform: uppercase;
  }

  .view-more {
    align-items: center;
    color: ${colors.blue};
    display: flex;
    font-size: ${fontSizes.mediumSmall};
    padding: 7px 0;
  }

  p {
    font-size: 1.5rem;
    color: ${colors.black};
  }
`;



// WEBPACK FOOTER //
// ./app/common/Lists/DisambiguationList/list/styles.js